import React, { useState, useEffect, useRef } from 'react';
import Modal from './Modal';
import './Home.css';

// Muscle group data - you can manually add YouTube video IDs here
const muscleGroupData = {
  'Abs': {
    title: 'Abs',
    videos: [
      // Add YouTube video IDs here, e.g., 'dQw4w9WgXcQ'
      // You can add multiple videos: ['videoId1', 'videoId2', 'videoId3']
    ],
    exercises: []
  },
  'Biceps': {
    title: 'Biceps',
    videos: [],
    exercises: [
      'Barbell bicep curl',
      'Dumbbell bicep curl',
      'Hammer curl',
      'Concentration curl',
      'Preacher curl',
      'Spider curl',
      'Cable bicep curl',
      'Incline dumbbell curl',
      'Zottman curl',
      'Reverse curl'
    ]
  },
  'Calves': {
    title: 'Calves',
    videos: [],
    exercises: []
  },
  'Chest': {
    title: 'Chest',
    videos: [],
    exercises: [
      'Chest press machine',
      'Incline chest press machine',
      'Dumbbell bench press',
      'Barbell bench press',
      'Smith machine bench press',
      'Incline dumbbell bench press',
      'Smith machine incline bench press',
      'Incline barbell bench press',
      'Decline barbell bench press',
      'Decline dumbbell bench press',
      'Push ups',
      'Bent knee push ups',
      'Incline push ups',
      'Decline push ups',
      'Dumbbell chest fly',
      'Incline dumbbell chest fly',
      'Low cable crossover',
      'High cable crossover',
      'Cable chest press',
      'Pec deck machine',
      'Chest dips'
    ]
  },
  'Forearm': {
    title: 'Forearm',
    videos: [],
    exercises: []
  },
  'Front and Side Delts': {
    title: 'Front and Side Delts',
    videos: [],
    exercises: [
      'Barbell overhead press',
      'Dumbbell overhead press',
      'Seated dumbbell press',
      'Arnold press',
      'Front raise',
      'Lateral raise',
      'Seated lateral raise',
      'Around the world',
      'Smith machine shoulder press',
      'Shoulder press machine',
      'Upright row',
      'Cable lateral raise',
      'Plate raise',
      'Single arm cable front raise',
      'Landmine press',
      'Push press'
    ]
  },
  'Front Traps and Neck': {
    title: 'Front Traps and Neck',
    videos: [],
    exercises: [
      'Dumbbell shrug',
      'Barbell shrug',
      'Cable upright row'
    ]
  },
  'Glutes': {
    title: 'Glutes',
    videos: [],
    exercises: []
  },
  'Hams': {
    title: 'Hams',
    videos: [],
    exercises: []
  },
  'Lats': {
    title: 'Lats',
    videos: [],
    exercises: [
      'Pull ups',
      'Chin ups',
      'Assisted pull ups',
      'Lat pulldown machine',
      'Cable lat pulldown',
      'Barbell row underhand grip',
      'Barbell row wide grip',
      'T bar row',
      'Single arm dumbbell row',
      'Seated cable row wide grip',
      'Seated cable row V grip'
    ]
  },
  'Lower Back': {
    title: 'Lower Back',
    videos: [],
    exercises: [
      'Back hyperextensions'
    ]
  },
  'Quads': {
    title: 'Quads',
    videos: [],
    exercises: []
  },
  'Rear Delts': {
    title: 'Rear Delts',
    videos: [],
    exercises: [
      'Face pulls',
      'Reverse fly machine',
      'Dumbbell reverse fly',
      'Bent over lateral raise'
    ]
  },
  'Triceps': {
    title: 'Triceps',
    videos: [],
    exercises: [
      'Close grip bench press',
      'Tricep dips',
      'Cable rope pushdown',
      'Cable bar pushdown',
      'Dumbbell overhead tricep extension',
      'Cable rope overhead tricep extension',
      'Skull crusher',
      'Cable tricep kickback',
      'Diamond push ups',
      'Bench dips',
      'One arm dumbbell extension',
      'Tricep press machine',
      'Tricep dip machine',
      'Dumbbell tricep kickback'
    ]
  },
  'Upper and MId Back': {
    title: 'Upper and Mid Back',
    videos: [],
    exercises: [
      'Barbell row wide grip',
      'T bar row',
      'Seated cable row wide grip',
      'Seated cable row V grip'
    ]
  }
};


const techniqueData = {
  'cluster': {
    title: 'Cluster Training',
    image: 'cluster',
    content: (
      <div>
      <h2>CLUSTER Example: <span className="example">3*6 (2+2+2, 85% 1RM)</span></h2>
      <p>Do 3 sets of 6 reps at 85% 1RM, each set split into 2 reps + 20s rest + 2 reps + 20s rest + 2 reps.</p>
      <p className="muted">Rest between cluster sets: 90–180 seconds.</p>
      <p className="summary">Summary: Heavy work with short intra-set breaks to maintain power/quality of reps.</p>
      </div>
    )
  },
  'constrast': {
    title: 'Contrast Training',
    image: 'constrast',
    content: (
      <div>
<h2>CONTRAST Example: <span className="example">1, 6, 1, 6, 1, 6 (85% / 70% 1RM)</span></h2>
<p>Alternate between singles (1 rep) at 85% 1RM and sets of 6 at 70% 1RM — total 6 sets. Rest ~3 minutes between sets.</p>
<p className="summary">Summary: Alternates heavy single reps and lighter multi-rep sets to train both max strength and work capacity.</p>
</div>
    )
  },
  'dropset': {
    title: 'Dropset',
    image: 'dropset',
    content: (
      <div>
<h2>DROPSET Example: <span className="example">3*(8, 8)</span></h2>
<p>One exercise performed in consecutive mini-sets <strong>without rest</strong>, while <strong>decreasing the weight</strong> each mini-set.</p>
<ul>
<li>Parentheses numbers show reps per subset. Weight must drop each subsequent subset.</li>
<li>Number before parentheses (3) = how many dropsets to perform.</li>
<li>Rest only between full dropsets — standard rest 90–120 seconds.</li>
</ul>
<p className="summary">Summary: Same exercise, multiple back-to-back subsets with reducing load.</p>
</div>
    )
  },
  'dynamic effort': {
    title: 'Dynamic Effort',
    image: 'dynamic effort',
    content: (
      <div>
<h2>DYNAMIC EFFORT Example: <span className="example">8*3 (50% 1RM, 60s)</span></h2>
<p>Perform 8 sets of 3 reps at 50% of 1RM, with 60 seconds rest between sets. Reps are done explosively.</p>
<p className="summary">Summary: Light weight, high speed — trains explosive power.</p>
</div>
    )
  },
  'myoset': {
    title: 'Myoset',
    image: 'myoset',
    content: (
      <div>
<h2>MYOSET Example: <span className="example">4*(12+2+2)</span></h2>
<p>Perform 12 reps to near-failure, rest 5–10 seconds, do 2 more reps, rest 5–10s, then 2 more — weight stays the same.</p>
<ul>
<li>The number before parentheses (4) = how many myosets to do.</li>
<li>Rest between full myosets: 90–180 seconds.</li>
</ul>
<p className="summary">Summary: Short intra-set rests extend work at the same load to increase time under tension.</p>
</div>
    )
  },
  'ascending set': {
    title: 'Ascending Set',
    image: 'rastuci set',
    content: (
      <div>
<h2>INCREASING (Ascending) SET Example: <span className="example">3*(8, 8, 5)</span></h2>
<p>One exercise done in successive mini-sets <strong>without rest</strong>, while <strong>increasing the weight</strong> each mini-set.</p>
<ul>
<li>Numbers in parentheses are reps per subset; weight increases each time.</li>
<li>Number before parentheses = total ascending sets to perform.</li>
<li>Rest between full ascending sets is standard (90–120 seconds).</li>
</ul>
<p className="summary">Summary: Same exercise, higher weight each mini-set with no rest between them.</p>
</div>
    )
  },
  'slow tempo': {
    title: 'Slow Tempo',
    image: 'spori tempo',
    content: (
      <div>
<h2>SLOW TEMPO Example: <span className="example">4210, 3030</span></h2>
<p>Tempo is shown with four digits: <strong>eccentric / pause at bottom / concentric / rest between reps</strong> (seconds).</p>
<ul>
<li><strong>4-2-1-0</strong>: 4s lowering, 2s hold, 1s lift, 0s rest between reps.</li>
<li><strong>3-0-3-0</strong>: 3s lowering, 0s pause, 3s lifting, 0s rest.</li>
</ul>
<p className="summary">Summary: Controls movement timing to increase tension and control.</p>
</div>
    )
  },
  'superset': {
    title: 'Superset',
    image: 'superset',
    content: (
      <div>
      <h2>SUPERSET Example: <span className="example">3*(8, 12)</span></h2>
      <p>Perform two (or three) exercises back-to-back <strong>without rest</strong> between them.</p>
      <ul>
      <li>The numbers in parentheses are reps for each exercise (e.g., 8 reps for the first, 12 for the second).</li>
      <li>The number before the parentheses (3) is how many total supersets to do.</li>
      <li>Rest only after the whole superset — standard rest 90–120 seconds.</li>
      </ul>
      <p className="summary">Summary: Consecutive exercises with no rest, then rest after the superset.</p>
      </div>
    )
  },
  'waveset': {
    title: 'Waveset',
    image: 'waveset',
    content: (
      <div>
<h2>WAVESET Example: <span className="example">6, 4, 2, 6, 4, 2</span></h2>
<p>Perform 6 sets following the rep pattern. Adjust weight so 6s are lighter, 4s heavier, 2s heaviest. Then repeat the wave.</p>
<p className="muted">Rest between sets ~3 minutes.</p>
<p className="summary">Summary: "Wave" the intensity for strength and neural adaptation.</p>
</div>
    )
  }
};

function Home() {
  const [selectedTechnique, setSelectedTechnique] = useState(null);
  const [expandedMuscleGroup, setExpandedMuscleGroup] = useState(null);
  const muscleDetailRef = useRef(null);

  const selectedMuscleGroup = expandedMuscleGroup ? muscleGroupData[expandedMuscleGroup] : null;

  const handleTechniqueClick = (techniqueKey) => {
    setSelectedTechnique(techniqueKey);
  };

  const handleCloseModal = () => {
    setSelectedTechnique(null);
  };

  const handleMuscleGroupClick = (muscleKey) => {
    if (expandedMuscleGroup === muscleKey) {
      setExpandedMuscleGroup(null); // Collapse if already expanded
    } else {
      setExpandedMuscleGroup(muscleKey); // Expand or switch to another
    }
  };

  useEffect(() => {
    if (
      expandedMuscleGroup &&
      muscleDetailRef.current &&
      typeof window !== 'undefined' &&
      window.innerWidth <= 768
    ) {
      window.requestAnimationFrame(() => {
        muscleDetailRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }, [expandedMuscleGroup]);

  // Get technique icons
  const techniqueKeys = Object.keys(techniqueData);
  const muscleKeys = Object.keys(muscleGroupData);

  return (
    <div className="home-container">
      <div className="hero-section">
        <h1>Welcome to Your Fitness Journey</h1>
        <p>Your personalized workout and nutrition guide</p>
      </div>
      
      <div className="container">
        <div className="card">
          <h2>About This Platform</h2>
          <p>
            This is your dedicated fitness coaching platform where you can access
            personalized meal plans, workout routines, and track your progress.
          </p>
          <p>
            Your coach has created a customized plan for you to help achieve your fitness goals.
          </p>
        </div>

        {/* Workout Techniques Section */}
        <div className="card">
          <h2 className="section-title">Workout Technique</h2>
          <div className="techniques-grid">
            {techniqueKeys.map((techniqueKey) => {
              const technique = techniqueData[techniqueKey];
              const imageName = (technique && technique.image) || techniqueKey;
              return (
                <div
                  key={techniqueKey}
                  className="technique-item"
                  onClick={() => handleTechniqueClick(techniqueKey)}
                >
                  <div className="technique-icon-wrapper">
                    <img
                      src={`/workout_techniques/${imageName}.png`}
                      alt={techniqueData[techniqueKey].title}
                      className="technique-icon"
                    />
                  </div>
                  <p className="technique-name">{techniqueData[techniqueKey].title}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Muscle Wiki Section */}
        <div className="card">
          <h2 className="section-title">Muscle Wiki</h2>
          <div className="muscle-wiki-container">
            <div className="techniques-grid">
              {muscleKeys.map((muscleKey) => (
                <div
                  key={muscleKey}
                  className={`technique-item ${expandedMuscleGroup === muscleKey ? 'active' : ''}`}
                  onClick={() => handleMuscleGroupClick(muscleKey)}
                >
                  <div className="technique-icon-wrapper">
                    <img
                      src={`/muscle_groups/${muscleKey}.png`}
                      alt={muscleGroupData[muscleKey].title}
                      className="technique-icon"
                    />
                  </div>
                  <p className="technique-name">{muscleGroupData[muscleKey].title}</p>
                </div>
              ))}
            </div>
            {selectedMuscleGroup && (
              <div className="muscle-video-section" ref={muscleDetailRef}>
                <h3 className="muscle-video-title">{selectedMuscleGroup.title} Workouts</h3>

                {selectedMuscleGroup.exercises && selectedMuscleGroup.exercises.length > 0 && (
                  <div className="exercise-list">
                    {selectedMuscleGroup.exercises.map((exercise) => (
                      <div key={exercise} className="exercise-item">
                        {exercise}
                      </div>
                    ))}
                  </div>
                )}

                <div className="videos-grid">
                  {selectedMuscleGroup.videos && selectedMuscleGroup.videos.length > 0 ? (
                    selectedMuscleGroup.videos.map((videoId, index) => (
                      <div key={index} className="video-wrapper">
                        <iframe
                          width="560"
                          height="315"
                          src={`https://www.youtube.com/embed/${videoId}`}
                          title={`${selectedMuscleGroup.title} Workout ${index + 1}`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          className="youtube-video"
                        ></iframe>
                      </div>
                    ))
                  ) : (
                    <div className="no-videos-message">
                      <p>Videos coming soon! Add YouTube video IDs in the code to feature them here.</p>
                      <p className="hint-text">Update the 'videos' array in Home.js for this muscle group when you are ready.</p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <h3>🥗 Nutrition Plans</h3>
            <p>Access detailed meal plans tailored to your fitness goals</p>
          </div>
          <div className="feature-card">
            <h3>💪 Training Programs</h3>
            <p>Follow structured workout routines designed for you</p>
          </div>
          <div className="feature-card">
            <h3>📊 Progress Reports</h3>
            <p>Track your progress and see your improvements over time</p>
          </div>
        </div>
      </div>

      {/* Modal for displaying technique details */}
      {selectedTechnique && (
        <Modal
          isOpen={!!selectedTechnique}
          onClose={handleCloseModal}
          title={techniqueData[selectedTechnique].title}
        >
          {techniqueData[selectedTechnique].content}
        </Modal>
      )}
    </div>
  );
}

export default Home;

